export default __webpack_public_path__ + "static/media/arrow_back_circle.703215cc.svg";